var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDropdownWidgetIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.936,
    height: 22,
    viewBox: "0 0 21.936 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13840",
    d: "M422.678 93.388a.932.932 0 0 0 1.411 0l1.358-1.573a.777.777 0 1 0-1.176-1.015l-.888 1.028-.888-1.028a.777.777 0 1 0-1.176 1.015z",
    transform: "translate(-407.26 -87.262)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13841",
    d: "M83.1 32.419h18.138a1.9 1.9 0 0 0 1.9-1.9V12.017a1.6 1.6 0 0 0-1.6-1.6H82.8a1.6 1.6 0 0 0-1.6 1.6v18.502a1.9 1.9 0 0 0 1.9 1.9zm-.346-20.4a.048.048 0 0 1 .048-.048h18.734a.048.048 0 0 1 .048.048v6.6c0 .006 0 .011-.007.016h-18.82c0-.005-.007-.01-.007-.016v-6.6zm0 8.2h18.83v10.3a.346.346 0 0 1-.346.346H83.1a.346.346 0 0 1-.346-.346v-10.3z",
    style: {
      fill: "#333"
    },
    transform: "translate(-81.197 -10.419)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13842",
    d: "M179.5 315.8h12.271a.777.777 0 0 0 0-1.553H179.5a.777.777 0 1 0 0 1.553z",
    transform: "translate(-174.745 -301.853)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13843",
    d: "M179.5 410.973h8.233a.777.777 0 1 0 0-1.553H179.5a.777.777 0 1 0 0 1.553z",
    transform: "translate(-174.745 -393.139)",
    style: {
      fill: "#333"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownWidgetIcon);
export default __webpack_public_path__ + "static/media/dropdown-widget-icon.98a79d6dba3852f1d1196681c0f00a78.svg";
export { ForwardRef as ReactComponent };